module.exports = __webpack_public_path__ + "img/new11_1_1.98906dae.png";